export enum TextTransformType {
	Uppercase = 1,
	Lowercase = 2,
	Titlecase = 3,
	Capitilized = 4,
	Trancuate = 5
}
